module.exports = __webpack_public_path__ + "img/bg.f3d9f3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/theme/assets/offline/bg.jpg
// module id = ./assets/theme/assets/offline/bg.jpg
// module chunks = 152